// extracted by mini-css-extract-plugin
export default {"password-info-message":"profile_password-info-message__B0PYv","action-link":"profile_action-link__pNPr5","password-criteria":"profile_password-criteria__KDLJN"};